var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.875,
    height: 15.75,
    viewBox: "0 0 16.875 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.125 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.75,2.25A2.813,2.813,0,1,1,3.937,5.063,2.813,2.813,0,0,1,6.75,2.25m0-1.125a3.938,3.938,0,1,0,3.938,3.938A3.938,3.938,0,0,0,6.75,1.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,16.875H11.25V14.062a2.813,2.813,0,0,0-2.813-2.813H5.063A2.813,2.813,0,0,0,2.25,14.062v2.813H1.125V14.062a3.938,3.938,0,0,1,3.938-3.938H8.438a3.938,3.938,0,0,1,3.938,3.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,2.25H18V3.375H12.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,5.063H18V6.188H12.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,7.875h3.938V9H12.375Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.49436e62.svg";
export { ForwardRef as ReactComponent };